var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer_box" }, [
    _c("div", { staticClass: "container_box" }, [
      _c("div", { staticClass: "nav_box" }),
      _vm._v(" "),
      _c("div", { staticClass: "info_box" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "logo_box",
              on: {
                click: function($event) {
                  return _vm.getIndex()
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: require("../assets/images/index_bot_logo.png"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "info_item",
              attrs: {
                target: "_blank",
                href: "https://beian.miit.gov.cn/#/Integrated/index"
              }
            },
            [
              _vm._v(
                "\n                    备案号：冀ICP备2025123743号\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "flex_column felx_border media_small_hide" }, [
          _c("div", { staticClass: "text_h1" }, [_vm._v("关注我们")]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_item" }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_kegy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_cp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚春棚")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_axgp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚大棚")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/sph.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/wx-code.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/wx.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/ks_axgp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/ks_kegy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/ks.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/dy_krgy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/dy.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "flex_row media_big_hide" }, [
          _c("div", { staticClass: "text_h1 media_small_hide" }, [
            _vm._v("关注我们")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_item" }, [
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_kegy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_cp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚春棚")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/sph_axgp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚大棚")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/sph.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../assets/images/wx-code.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/wx.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/ks_axgp.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔爱心公棚")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/ks_kegy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/ks.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "top-start", trigger: "hover" } },
                  [
                    _c("div", { staticClass: "footer_code" }, [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/dy_krgy.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("开尔鸽业")])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        slot: "reference",
                        src: require("../assets/images/dy.png"),
                        alt: ""
                      },
                      slot: "reference"
                    })
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          id: "imgurl",
          href:
            "https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91130293MAEQGW203A-SAIC_SHOW_10000091130293MAEQGW203A1756978688683&signData=MEUCIB2VPie7BhVOv9SKZeLxOUPu55JDbMZ18FYdbUxfTZ8vAiEAoxNC5BGOv1taNqb79rLKHRAh5su7LC+LMU5WcXxcXlc=",
          title: "电子营业执照",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("../assets/images/lz4.png"),
            width: "32",
            border: "0"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex_column felx_border media_small_hide" },
      [
        _c("div", { staticClass: "text_h1" }, [_vm._v("联系我们")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            { attrs: { href: "https://kaiergeye.com/", target: "_blank" } },
            [_vm._v("公棚联系方式")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex_column felx_border media_small_hide" },
      [
        _c("div", { staticClass: "text_h1" }, [_vm._v("相关网站")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            { attrs: { href: "https://kaiergeye.com/", target: "_blank" } },
            [_vm._v("拍卖")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("a", { attrs: { href: "https://xgyun.com", target: "_blank" } }, [
            _vm._v("信鸽云")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://auctions.pipa.be/zh-hans/?utm_source=kaier",
                target: "_blank"
              }
            },
            [_vm._v("PIPA")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex_row felx_bottom_border media_big_hide" },
      [
        _c("div", { staticClass: "text_h1" }, [_vm._v("联系我们")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            { attrs: { href: "https://kaiergeye.com/", target: "_blank" } },
            [_vm._v("公棚联系方式")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex_row felx_bottom_border media_big_hide" },
      [
        _c("div", { staticClass: "text_h1" }, [_vm._v("相关网站")]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            { attrs: { href: "https://kaiergeye.com/", target: "_blank" } },
            [_vm._v("拍卖")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            {
              attrs: { href: "https://kaier.cc/introduction", target: "_blank" }
            },
            [_vm._v("信鸽云")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://auctions.pipa.be/zh-hans/?utm_source=kaier",
                target: "_blank"
              }
            },
            [_vm._v("PIPA")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-209e9006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209e9006","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer-common.vue
// module id = null
// module chunks = 